import React from 'react';
import { Card, Space, Divider } from 'antd';
import { LinkOutlined } from '@ant-design/icons';

interface ExternalTool {
  title: string;
  description: string;
  url: string;
  category: string;
}

const tools: ExternalTool[] = [
  // 区块链浏览器
  {
    title: 'Etherscan',
    description: '以太坊区块链浏览器',
    url: 'https://etherscan.io',
    category: '区块链浏览器'
  },
  {
    title: 'BSCScan',
    description: 'BSC区块链浏览器',
    url: 'https://bscscan.com',
    category: '区块链浏览器'
  },
  {
    title: 'Polygonscan',
    description: 'Polygon区块链浏览器',
    url: 'https://polygonscan.com',
    category: '区块链浏览器'
  },
  
  // DeFi工具
  {
    title: 'DeFiPulse',
    description: 'DeFi协议数据统计',
    url: 'https://defipulse.com',
    category: 'DeFi工具'
  },
  {
    title: 'DeFiLlama',
    description: 'DeFi协议TVL统计',
    url: 'https://defillama.com',
    category: 'DeFi工具'
  },
  {
    title: 'CoinGecko',
    description: '加密货币价格追踪',
    url: 'https://coingecko.com',
    category: 'DeFi工具'
  },
  
  // 开发工具
  {
    title: 'Remix IDE',
    description: '在线Solidity开发环境',
    url: 'https://remix.ethereum.org',
    category: '开发工具'
  },
  {
    title: 'OpenZeppelin Wizard',
    description: '智能合约代码生成器',
    url: 'https://wizard.openzeppelin.com',
    category: '开发工具'
  },
  {
    title: 'Tenderly',
    description: '智能合约调试和监控',
    url: 'https://tenderly.co',
    category: '开发工具'
  },
  
  // 安全工具
  {
    title: 'Token Sniffer',
    description: '代币安全检测',
    url: 'https://tokensniffer.com',
    category: '安全工具'
  },
  {
    title: 'Honeypot Checker',
    description: '蜜罐检测工具',
    url: 'https://honeypot.is',
    category: '安全工具'
  },
  {
    title: 'Revoke.cash',
    description: '代币授权撤销工具',
    url: 'https://revoke.cash',
    category: '安全工具'
  }
];

const ExternalTools: React.FC = () => {
  const categories = Array.from(new Set(tools.map(tool => tool.category)));

  const openTool = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <Card title="外部工具" style={{ maxWidth: 'var(--tool-container-xl)', margin: '0 auto', padding: 'var(--spacing-md)' }}>
      <div style={{ marginBottom: 16, color: '#666' }}>
        收集了一些常用的Web3开发和分析工具，点击按钮可直接访问
      </div>
      
      {categories.map((category, index) => (
        <div key={category}>
          {index > 0 && <Divider />}
          <div style={{ marginBottom: 16 }}>
            <h3 style={{ margin: '0 0 12px 0', color: '#1890ff' }}>{category}</h3>
            <Space wrap>
              {tools
                .filter(tool => tool.category === category)
                .map(tool => (
                  <Card
                    key={tool.title}
                    size="small"
                    style={{ 
                      width: 280, 
                      cursor: 'pointer',
                      transition: 'all 0.3s'
                    }}
                    hoverable
                    onClick={() => openTool(tool.url)}
                  >
                    <Space direction="vertical" size="small" style={{ width: '100%' }}>
                      <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center' 
                      }}>
                        <strong>{tool.title}</strong>
                        <LinkOutlined style={{ color: '#1890ff' }} />
                      </div>
                      <div style={{ 
                        fontSize: 12, 
                        color: '#666',
                        lineHeight: '1.4'
                      }}>
                        {tool.description}
                      </div>
                    </Space>
                  </Card>
                ))}
            </Space>
          </div>
        </div>
      ))}
      
      <Divider />
      <div style={{ textAlign: 'center', color: '#999', fontSize: 12 }}>
        更多工具持续更新中...
      </div>
    </Card>
  );
};

export default ExternalTools; 